import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserWalletComponent } from './user-wallet/user-wallet.component';
import { TablesComponent } from './tables/tables.component';
import { MapsComponent } from './maps/maps.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DoctorInfoComponent } from './doctors/doctor-info/doctor-info.component';
import { AdminLayoutRoutes } from './admin-layout.routing';
import { MessageComponent } from './message/message.component';
import { ChatComponent } from './chat/chat.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PatientProfileComponent } from './patient-profile/patient-profile.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { DoctorCalendarComponent } from './doctors/doctor-calendar/doctor-calendar.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { VisitsComponent } from './visits/visits.component';
import { DoctorsComponent } from './doctors/doctors.component';
import { AboutUsComponent } from './website-content/about-us/about-us.component';
import { ConditionsComponent } from './website-content/conditions/conditions.component';
import { PrivacyComponent } from './website-content/privacy/privacy.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { PersianDatePickerComponent } from 'src/app/components/date-picker/persian-date-picker/persian-date-picker.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PaginatorModule } from 'primeng/paginator';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        RouterModule.forChild(AdminLayoutRoutes),
        TranslateModule,
        FormsModule,
        SharedModule,
        ImageCropperComponent,
        ReactiveFormsModule,
        NgxMaterialTimepickerModule.setOpts('ar-AE', 'arab'),
        ToastModule,
        AutoCompleteModule,
        PaginatorModule,
        PersianDatePickerComponent
    ],
    declarations: [
        UserWalletComponent,
        // TablesComponent,
        // SettingsComponent,
        // MapsComponent,
        DashboardComponent,
        DoctorInfoComponent,
        MessageComponent,
        ChatComponent,
        DoctorCalendarComponent,
        PatientProfileComponent,
        DoctorsComponent,
        VisitsComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: [
        MessageService
    ]
})

export class AdminLayoutModule { }
